import { render, staticRenderFns } from "./DetailsRequestAttachments.vue?vue&type=template&id=0633d31a&scoped=true"
import script from "./DetailsRequestAttachments.vue?vue&type=script&lang=js"
export * from "./DetailsRequestAttachments.vue?vue&type=script&lang=js"
import style0 from "./DetailsRequestAttachments.vue?vue&type=style&index=0&id=0633d31a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0633d31a",
  null
  
)

export default component.exports